import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { Link } from '@ui/Link';
import { getShafaAbsoluteUrl } from '@utils/common';
import ArrowLeftIcon from '@svg/arrows-left.svg';

import s from './Breadcrumbs.sss';

export type Breadcrumb = {
  title: string
  url: string
};

export type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[]
  className?: string
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  className,
}) => {
  const history = useHistory();
  const breadcrumbsWithRoot = [
    { title: 'Shafa.ua', url: history.createHref({ pathname: '/' }) },
    ...breadcrumbs,
  ];

  return (
    <>
      <Helmet>
        {/*
          Breadcrumb structured data according to:
          https://developers.google.com/search/docs/appearance/structured-data/breadcrumb#json-ld
        */}
        <script type="application/ld+json">
          {
            JSON.stringify(
              {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: breadcrumbsWithRoot.map(
                  (breadcrumb, i) => {
                    // Build absolute url
                    const url = getShafaAbsoluteUrl(breadcrumb.url);

                    return {
                      '@type': 'ListItem',
                      position: i + 1,
                      name: breadcrumb.title,
                      item: url,
                    };
                  },
                ),
              },
            )
          }
        </script>
      </Helmet>

      <div className={classNames(s.root, className)}>
        {
          breadcrumbsWithRoot.map(
            ({ title, url }, i, arr) => (
              <Link
                key={i}
                className={classNames(
                  s.breadcrumb,
                  {
                    [s.previousPageBreadcrumb]: i === arr.length - 1,
                  },
                )}
                theme="black"
                href={url}
              >
                <ArrowLeftIcon
                  className={s.arrow}
                  width='16'
                  height='16'
                />
                {title}
              </Link>
            ),
          )
        }
      </div>
    </>
  );
};
